import App from "./App.vue";
import router from "./router";
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import store from "./store/index";
import "./sass/index.scss";

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;

axios.defaults.headers.common["Api-Key"] =
  process.env.VUE_APP_ONBOARDING_API_KEY;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
